import { useMutation, useQueryClient } from "react-query";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import AppButton from "../../components/AppButton";
import { getModelLabel } from "./constants";
import { setActiveModel } from "./services";

const ActivateModelDialog = ({
  modelName,
  onClose,
}: {
  modelName: string | null;
  onClose: () => void;
}) => {
  const queryClient = useQueryClient();

  const setActiveModelMutation = useMutation(
    (name: string) => setActiveModel(name),
    { onSuccess: () => queryClient.invalidateQueries("ml-analysis-metrics") }
  );

  return (
    <Dialog open={modelName !== null} onClose={onClose}>
      <DialogTitle>
        Activer le modèle « {modelName ? getModelLabel(modelName) : ""} » en
        production ?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Attention, ce modèle remplacera le modèle actuellement utilisé en
          production pour générer les prévisions d'annulation.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <AppButton intent="secondary" onClick={onClose}>
          Annuler
        </AppButton>
        <AppButton
          disabled={setActiveModelMutation.isLoading}
          onClick={() => {
            if (modelName) {
              setActiveModelMutation.mutate(modelName, {
                onSettled: onClose,
              });
            }
          }}
        >
          Valider
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default ActivateModelDialog;
